/**
 */
export const GatewayError = 'GatewayError'
export const NetworkError = 'NetworkError'
export const NotAuthenticated = 'NotAuthenticated'
export const Forbidden = 'Forbidden'
export const ApiNotFound = 'ApiNotFound'
export const TooManyRequest = 'TooManyRequest'
